import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import MessagesDollar from './icon-messages-dollar.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MessagesDollar {...validProps} />;
}
SvgComponent.iconName = 'messagesDollar';

export const MessagesDollarIcon = svgIconWrapper(SvgComponent);
